// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/campanhaService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  CampanhaResumo, CampanhaDetalhe, CriarCampanhaRequest, AtualizarCampanhaRequest,
  PublicoPreview, CampanhaEnvio, DispararResultado,
} from '../types';

const BASE = '/api/campanhas';

export const campanhaService = {
  async getAll(): Promise<CampanhaResumo[]> {
    const { data } = await apiClient.get<CampanhaResumo[]>(BASE);
    return data;
  },
  async getById(id: number): Promise<CampanhaDetalhe> {
    const { data } = await apiClient.get<CampanhaDetalhe>(`${BASE}/${id}`);
    return data;
  },
  async create(req: CriarCampanhaRequest): Promise<CampanhaDetalhe> {
    const { data } = await apiClient.post<CampanhaDetalhe>(BASE, req);
    return data;
  },
  async update(id: number, req: AtualizarCampanhaRequest): Promise<CampanhaDetalhe> {
    const { data } = await apiClient.put<CampanhaDetalhe>(`${BASE}/${id}`, req);
    return data;
  },
  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
  async publico(id: number): Promise<PublicoPreview> {
    const { data } = await apiClient.get<PublicoPreview>(`${BASE}/${id}/publico`);
    return data;
  },
  async disparar(id: number): Promise<DispararResultado> {
    const { data } = await apiClient.post<DispararResultado>(`${BASE}/${id}/disparar`, {});
    return data;
  },
  async reprocessar(id: number): Promise<DispararResultado> {
    const { data } = await apiClient.post<DispararResultado>(`${BASE}/${id}/reprocessar`, {});
    return data;
  },
  async envios(id: number): Promise<CampanhaEnvio[]> {
    const { data } = await apiClient.get<CampanhaEnvio[]>(`${BASE}/${id}/envios`);
    return data;
  },
};
